module.exports = __webpack_public_path__ + "img/card-background-2.779fecc.webp";